import { Component, OnInit, Inject } from '@angular/core';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "../models/types";

@Component({
    selector: 'app-side-effect-replace-bonding',
    templateUrl: './side-effect-replace-bonding.component.html',
    styleUrls: ['./side-effect-replace-bonding.component.scss'],
    standalone: false
})
export class SideEffectReplaceBondingComponent implements OnInit {

    _configuration: any;

    get configuration(): any {
        if (this._configuration == null) this._configuration = {
            bondBeingReplacedId: "",
            replacingBondId: ""
        }
        return this._configuration;
    }

    set configuration(value: any) {
        this._configuration = value;
    }

    get replacedBondContext(): string {
        return this.configuration.bondBeingReplacedId;
    }

    set replacedBondContext(value: string) {
        this.configuration.bondBeingReplacedId = value;
    }

    get replacingBondContext(): string {
        return this.configuration.replacingBondId;
    }

    set replacingBondContext(value: string) {
        this.configuration.replacingBondId = value;
    }


    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.configuration = data.configuration;
    }

    ngOnInit() {
    }

}
